export enum ReIdentificationStatus {
    Queued = "Queued",
    QueuedForRetryByUser = "QueuedForRetryByUser",
    Scheduled = "Scheduled",
    Downloading = "Downloading",
    Analyzing = "Analyzing",
    ResultsReady = "ResultsReady",
    Failed = "Failed",
}
